import {EDraggableFrameUniqueTypeIds} from 'components/draggable-frame';
import {useAppDispatch} from 'store/config/hooks';
import {apiRequestProgressSliceActions} from 'store/slices/api-request-progress-slice/api-request-progress-slice';
import {createRequestProgress} from 'store/slices/api-request-progress-slice/api-request-progress-slice-thunks';
import {EDraggableFrameType, draggableFramesActions} from 'store/slices/draggable-frames-slice';

interface ICreateProgressFrameArgs {
    title?: string;
    extra?: any;
}

export const useApiRequestProgressFrame = () => {
    const dispatch = useAppDispatch();

    const {openDraggableFrame} = draggableFramesActions;
    const {
        updateRequestProgressPercent,
        removeRequestProgress,
    } = apiRequestProgressSliceActions;

    const createProgressFrame = async (args?: ICreateProgressFrameArgs) => {
        dispatch(openDraggableFrame({
            type: EDraggableFrameType.ApiRequestProgressFrame,
            id: EDraggableFrameUniqueTypeIds.ApiRequestProgressFrame,
        }));

        const requestProgressId = await dispatch(createRequestProgress({
            title: args?.title,
            extra: args?.extra,
        })).unwrap();

        const handleProgress = (event: ProgressEvent<EventTarget>) => {
            const {loaded, total} = event;

            const uploadProgressPercent = Math.trunc((loaded / total) * 100);
            dispatch(updateRequestProgressPercent({
                id: requestProgressId,
                progressPercent: uploadProgressPercent,
            }));
        };

        const rollbackProgress = () => {
            dispatch(removeRequestProgress(requestProgressId));
        };

        return {
            handleProgress,
            rollbackProgress,
            requestProgressId,
        };
    };

    return {
        createProgressFrame,
    };
};
